import React, { useRef, useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Chip from "@material-ui/core/Chip";
import "../styles/navigoDashboardStyles.scss";
import { TextField, IconButton, Modal } from "@material-ui/core";
import filterApplied from "../../../../../assets/icons/filter-applied-icon.svg";
import funnelIcon from "../../../../../assets/icons/funnel.svg";
import FontIcon from "react-md/lib/FontIcons";
import EventService from "../../../../../service/event/EventService";
import moment from "moment";
import Button from "react-md/lib/Buttons/Button";
import GlobalSkeletonLoader from "../../../../../components/common/GlobalSkeletonLoader";
import NavigoDashboardUtils, {
  formatDigitisationCost,
} from "../services/DigitiseDashboardUtils";
import Helper from "util/Helper";
import { TextField as TextField2 } from "react-md";
import { Col } from "react-flexbox-grid";
import PatientTracking from "../../../../ops/modules/patients/modules/tracking/components/PatientTracking";
import PatientsService from "../../../../ops/modules/patients/service/PatientsService";
import eyeIcon from "../../../../../assets/icons/eye-orange.svg";
import UpdateTrackingService from "../../../../ops/modules/patients/modules/new-bridge/components/Update_tracking/service/UpdateTrackingService";

const documentStatus = [
  { value: 1, name: "Reviewed" },
  { value: 2, name: "Not reviewed" },
  { value: 3, name: "Saved as draft" },
  { value: 4, name: "In progress" },
];

// Extraction model shown as a small tag beneath the digitisation date. Match by family
// (qwen / gemini) so a version bump (e.g. qwen3-vl-8b -> qwen3-vl-32b) still maps correctly;
// legacy/blank -> gemini. The real model names are NOT exposed on the frontend — they are
// surfaced as generic labels: gemini -> "model1", qwen -> "model2". Colour distinguishes them.
function getModelInfo(model) {
  const isQwen = String(model || "")
    .toLowerCase()
    .includes("qwen");
  return isQwen
    ? { name: "model2", color: "#ef7c01" } // qwen
    : { name: "model1", color: "rgba(48,197,63,1)" }; // gemini
}

function DocumentDashboard(props) {
  const [appointmentsList, setAppointmentsList] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuFor, setMenuFor] = useState({});
  const [componentMounted, setComponentMounted] = useState(false);
  const navigoDashboardUtils = new NavigoDashboardUtils();
  const patientService = new PatientsService();
  const updatetrackingservice = new UpdateTrackingService();
  const helper = new Helper();
  const [patientId, setPatientId] = useState("");
  const [appointmentId, setAppointmentId] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [pageNum, setPageNum] = useState(1);
  const [pageSize, setPageSize] = useState(30);
  const [filterObj, setFilterObj] = useState({
    pageNum: 1,
    pageSize: 30,
  });
  const [onlyPageChange, setOnlyPageChange] = useState(false);
  const handleClick = (event, document) => {
    setAnchorEl(event.currentTarget);
    setMenuFor(document);
    changeScreen(1, document);
  };
  const [noAppointments, setNoAppointments] = useState(true);
  const [loading, setLoading] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [numFrom, setNumFrom] = useState(0);
  const [numTo, setNumTo] = useState(0);
  const [creationDateFrom, setCreationDateFrom] = useState(null);
  const [creationDateTo, setCreationDateTo] = useState(null);
  const [digitisationDateFrom, setDigitisationDateFrom] = useState(null);
  const [digitisationDateTo, setDigitisationDateTo] = useState(null);
  const [appointmentDateFrom, setAppointmentDateFrom] = useState(null);
  const [appointmentDateTo, setAppointmentDateTo] = useState(null);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [openFilter, setOpenFilter] = useState(0);
  const [maxDate, setMaxDate] = useState("");
  const skip = useRef(30);
  const [searchPid, setSearchPid] = useState("");
  const [searchAppid, setSearchAppid] = useState("");
  const [
    filterServiceProviderNameOptions,
    setFilterServiceProviderNameOptions,
  ] = useState([]);
  const [serviceProviderNameOptions, setServiceProviderNameOptions] = useState(
    []
  );
  const [serviceCodeOptions, setServiceCodeOptions] = useState([]);
  const [filterServiceCodeOptions, setFilterServiceCodeOptions] = useState([]);
  const [accountCodeOptions, setAccountCodeOptions] = useState([]);
  const [filterAccountCodeOptions, setFilterAccountCodeOptions] = useState([]);
  const [filterModesOptions, setFilterModesOptions] = useState([]);
  const [statusFilterValue, setStatusFilterValue] = useState([]);
  const [removeFilters, setRemoveFilters] = useState(false);
  const [digitiseModal, setDigitiseModal] = useState(false);
  const [documentIds, setDocumentIds] = useState([]);
  const [selectedDocumentId, setSelectedDocumentId] = useState(0);
  const [detail, setDetail] = useState([]);
  const [digitalDocument, setDigitalDocument] = useState(null);
  const [token, setToken] = useState("");
  const [digitiseSuccessModal, setDigitiseSuccessModal] = useState(false);
  const [databaseModal, setDatabaseModal] = useState(false);
  const [labTestData, setLabTestData] = useState([]);
  const [subLabTestData, setSubLabTestData] = useState([]);
  const [labPagesData, setLabPagesData] = useState([]);
  const [tempSynonyms, setTempSynonyms] = React.useState(
    labPagesData[0]?.items?.[0]?.subTest?.synonyms || []
  );

  const isInitialMount = useRef(true);

  useEffect(() => {
    if (!props.dashboardFilter) return;

    // apply filter from parent on remount
    setFilterObj({
      ...props.dashboardFilter,
      pageNum: props.dashboardFilter.pageNum || 1,
    });

    setPageNum(props.dashboardFilter.pageNum || 1);

    isInitialMount.current = false;
  }, []);

  useEffect(() => {
    // handleGetAllAppointments();
    handleFetchAccountCodeOpt("");
    setComponentMounted(true);
    generateDocumentToken();
  }, []);

  // useEffect(() => {
  //   if (!componentMounted) return;

  //   handleGetAllAppointments();
  // }, [
  //   filterObj.patientIds,
  //   filterObj.appointmentIds,
  //   filterObj.accountCodes,
  //   filterObj.serviceID,
  //   filterObj.serviceProviderID,
  //   filterObj.status,
  //   filterObj.updatedAt,
  //   filterObj.digitisationDate,
  //   filterObj.appointmentDate,
  //   filterObj.pageNum,
  // ]);

  useEffect(() => {
    if (componentMounted && onlyPageChange == true) {
      setFilterObj({ ...filterObj, pageNum: pageNum });
    }
  }, [onlyPageChange]);
  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setMaxDate(today);
  }, []);

  useEffect(() => {
    if (!componentMounted) return;

    skip.current = 30;
    handleGetAllAppointments();
  }, [filterObj, componentMounted]);

  const handleFetchServiceCodeOpt = (str) => {
    navigoDashboardUtils.getServicesByFilter(
      {
        pageNum: 0,
        pageSize: 0,
        nameMatch: [],
        name: str,
      },
      (res) => {
        setOnlyPageChange(false);
        if (res && res.services && res.services.length > 0) {
          let allList = [];

          allList = res.services.map((service) => {
            return { ...service };
          });
          setServiceCodeOptions(allList);
        } else {
          setServiceCodeOptions([]);
        }
      },
      (err) => {
        setLoading(false);
        setNoAppointments(true);
        EventService.emit("showError", {
          message: `Error: ${err?.message}`,
        });
      }
    );
  };
  const handleFetchServiceProviderNameOpt = (str) => {
    navigoDashboardUtils.getServiceProvidersByFilter(
      {
        pageNum: 0,
        pageSize: 0,
        nameMatch: [],
        name: str,
      },
      (res) => {
        setOnlyPageChange(false);
        if (res && res.providers && res.providers.length > 0) {
          let allList = [];

          allList = res.providers.map((service) => {
            return { ...service };
          });
          // allList = filterUniqueByServiceProviderName(allList);
          setServiceProviderNameOptions(allList);
        } else {
          setServiceProviderNameOptions([]);
        }
      },
      (err) => {
        setLoading(false);
        setNoAppointments(true);
        EventService.emit("showError", {
          message: `Error: ${err?.message}`,
        });
      }
    );
  };
  const handleGetAllAppointments = (type = 1, btnType = 0) => {
    setLoading(true);

    navigoDashboardUtils.fetchAppointments(
      filterObj,
      (res) => {
        setOnlyPageChange(false);
        if (res && res.digitisationData && res.digitisationData.length > 0) {
          let allList = [];

          allList = res.digitisationData.map((service) => {
            return { ...service };
          });
          let localNumFrom, localNumTo;
          if (type === 1) {
            localNumFrom = 1;
            localNumTo = Math.min(30, res.resultCount);
          } else if (type === 2) {
            if (btnType === 0) {
              localNumTo = numFrom - 1;
              localNumFrom = Math.max(numFrom - 30, 1);
            } else {
              localNumFrom = numTo + 1;
              localNumTo = Math.min(numTo + 30, res.resultCount);
            }
          } else if (type === 3) {
            localNumFrom = numFrom;
            localNumTo = numTo;
          }
          setAppointmentsList([...allList]);
          setNoAppointments(false);
          setNumFrom(localNumFrom);
          setNumTo(localNumTo);
          setTotalCount(res.totalCount);
          setLoading(false);
        } else {
          setAppointmentsList([]);
          setNoAppointments(true);
          setLoading(false);
        }
        setRemoveFilters(false);
      },
      (err) => {
        setLoading(false);
        setAppointmentsList([]);
        setNoAppointments(true);
        setRemoveFilters(false);
        EventService.emit("showError", {
          message: `Error: ${err?.message}`,
        });
      }
    );
  };

  const changeScreen = (opt, data) => {
    if (opt === 1) {
      props.setView(1, data.documentId, filterObj);
    }
  };

  const handlePrevNextAppoint = (arg) => {
    setOnlyPageChange(true);
    if (arg) {
      setPageNum((prevPage) => prevPage + 1);
    } else {
      if (pageNum > 1) {
        setPageNum((prevPage) => (prevPage > 1 ? prevPage - 1 : 1));
      }
    }
  };

  // useEffect(() => {
  //   if (!patientId && !appointmentId && !phoneNumber && componentMounted) {
  //     handleGetAllAppointments();
  //   }
  // }, [patientId, appointmentId, phoneNumber]);

  useEffect(() => {
    if (componentMounted && removeFilters === false) {
      setFilterObj({
        ...filterObj,
        pageNum: 1,
        status: statusFilterValue.flatMap((e) => [e.value]),
      });
      setPageNum(1);
    }
  }, [statusFilterValue]);

  useEffect(() => {
    if (componentMounted && removeFilters === false) {
      setFilterObj({
        ...filterObj,
        pageNum: 1,
        accountCodes: filterAccountCodeOptions.map((e) => {
          return e.accountCode;
        }),
      });
      setPageNum(1);
    }
  }, [filterAccountCodeOptions]);
  useEffect(() => {
    if (componentMounted && removeFilters === false) {
      setFilterObj({
        ...filterObj,
        pageNum: 1,
        serviceID: filterServiceCodeOptions.map((e) => {
          return e.id;
        }),
      });
      setPageNum(1);
    }
  }, [filterServiceCodeOptions]);
  useEffect(() => {
    if (componentMounted && removeFilters === false) {
      setFilterObj({
        ...filterObj,
        pageNum: 1,
        serviceProviderID: filterServiceProviderNameOptions.map((e) => {
          return e.id;
        }),
      });
      setPageNum(1);
    }
  }, [filterServiceProviderNameOptions]);

  function filterUniqueByAccountCode(arr) {
    const seen = new Map();
    return arr.filter(
      (item) => !seen.has(item.accountCode) && seen.set(item.accountCode, true)
    );
  }
  const handleFetchAccountCodeOpt = (str) => {
    navigoDashboardUtils.getAccountsByFilter(
      {
        pageNum: 0,
        pageSize: 0,
        accountCodeMatch: [],
        accountCodes: str,
      },
      (res) => {
        setOnlyPageChange(false);
        if (res && res.accounts && res.accounts.length > 0) {
          let allList = [];

          allList = res.accounts.map((service) => {
            return { ...service };
          });
          allList = filterUniqueByAccountCode(allList);
          setAccountCodeOptions(allList);
        } else {
          setAccountCodeOptions([]);
        }
      },
      (err) => {
        setLoading(false);
        setNoAppointments(true);
        EventService.emit("showError", {
          message: `Error: ${err?.message}`,
        });
      }
    );
  };

  function getStatusName(statusCode) {
    const status = documentStatus.find((s) => s.value === statusCode);
    return status ? status.name : "Unknown Status";
  }

  const onRefresh = () => {
    handleGetAllAppointments();
  };

  const areFiltersApplied = () => {
    if (
      filterObj?.updatedFrom?.from != null ||
      filterObj?.updatedTo?.to != null ||
      filterObj?.appointmentDate?.from != null ||
      filterObj?.appointmentDate?.to != null ||
      filterObj?.digitisationDate?.from != null ||
      filterObj?.digitisationDate?.to != null ||
      filterObj?.accountCode?.length > 0 ||
      filterObj?.status?.length > 0
    ) {
      return true;
    } else {
      return false;
    }
  };
  const resetFilters = () => {
    let resetFilterObj = filterObj;
    delete resetFilterObj.updatedAt;
    delete resetFilterObj.appointmentDate;
    delete resetFilterObj.digitisationDate;
    delete resetFilterObj.accountCode;
    delete resetFilterObj.status;

    setFilterObj({
      ...resetFilterObj,
      pageNum: 1,
    });
    setPageNum(1);
    setOpenFilter(0);
    setOpenBackdrop(false);
  };
  useEffect(() => {
    if (removeFilters === true) {
      setFilterServiceProviderNameOptions([]);
      setFilterServiceCodeOptions([]);
      setFilterAccountCodeOptions([]);
      setFilterModesOptions([]);
      setStatusFilterValue([]);
      resetFilters();
    }
  }, [removeFilters]);
  useEffect(() => {
    handleFetchServiceCodeOpt("");
    handleFetchServiceProviderNameOpt("");
  }, []);

  const handlePatientIdChange = (e) => {
    const id = e.target.value;
    setPatientId(id);
    if (!id) return;
    navigoDashboardUtils.getDocumentId(
      id,
      (res) => {
        const docs = Array.isArray(res)
          ? res.map((item) => item.document).filter(Boolean)
          : [];

        setDocumentIds(docs);
      },
      (err) => {
        console.error("Error fetching documents", err);
        setDocumentIds([]);
      }
    );
  };

  const handleDigitise = () => {
    if (!selectedDocumentId) {
      alert("Please select a document ID first.");
      return;
    }
    const body = {
      documentId: parseInt(selectedDocumentId),
    };

    navigoDashboardUtils.digitiseNow(
      body,
      (res) => {
        setDigitiseModal(false);
        setPatientId("");
        setDigitiseSuccessModal(true);
        setDocumentIds([]);
        setSelectedDocumentId(0);
        EventService.emit("showError", {
          message: `Please check it in 10 minutes.`,
        });
      },
      (err) => {
        EventService.emit("showError", {
          message: `Error: ${err?.message}`,
        });
      }
    );
  };

  const onDocumentIdUpdate = (e) => {
    const selectedId = e.target.value;
    setSelectedDocumentId(selectedId);

    const selectedDocument = documentIds.find((x) => x.id == selectedId);

    setDetail(selectedDocument);
  };
  const viewDocument = () => {
    const url = detail.url;
    if (url) {
      window.open(url + "?token=" + token.toString(), "_blank");
    }
  };

  const generateDocumentToken = () => {
    patientService.getAndSaveDocumentToken(
      (response) => {
        localStorage.setItem("zy.bridge.doc.token", JSON.stringify(response));
        setToken(response.token);
      },
      (error) => {}
    );
  };
  const fire = (text, index) => {
    if (text.length > 1) {
      getLabTest(text);
    }
  };

  const getLabTest = (text) => {
    updatetrackingservice.getLabTest(
      text,
      (data) => {
        if (data) setLabTestData(data);
        setSubLabTestData([]);
      },
      (error) => {
        console.error("Lab Test Fetch Failed", error);
      }
    );
  };
  const OnSelect = (e) => {
    const selectedLabTest = labTestData.find((item) => item.value === e);
    const selectedLabel = selectedLabTest?.label;

    setLabPagesData((prev) => {
      const updated = [...prev];
      if (!updated[0]) updated[0] = { items: [] };

      const existingItem = updated[0].items[0] || {};

      updated[0].items[0] = {
        ...existingItem,
        labTest: { value: e, label: selectedLabel },
        subTest: {
          ...existingItem.subTest,
          subTestCode: { label: "", value: "" },
          loincCode: "",
        },
      };

      return updated;
    });
  };

  const getSubLabTests = (text, labTestId) => {
    updatetrackingservice.getSubTest(
      labTestId,
      text,
      (data) => {
        setSubLabTestData(data || []);
      },
      (error) => {
        console.error("SubTest fetch error", error);
      }
    );
  };

  const handleSubTestSelect = (selectedOption) => {
    if (!selectedOption) return;

    const labTest = labPagesData?.[0]?.items?.[0]?.labTest?.value;
    const subTestValue = selectedOption.value;

    if (labTest && subTestValue) {
      updatetrackingservice.getSubTestData(
        labTest,
        subTestValue,
        (data) => {
          setLabPagesData((prev) => {
            const updated = [...prev];
            if (!updated[0]) updated[0] = { items: [] };

            updated[0].items[0] = {
              ...(updated[0].items[0] || {}),
              subTest: {
                ...(updated[0].items[0]?.subTest || {}),
                value: subTestValue,
                label: selectedOption.label,
                loincCode: data.loincName || "",
                synonyms: [],
              },
            };

            return updated;
          });

          updatetrackingservice.getSynonyms(
            subTestValue,
            (synonymsRes) => {
              setLabPagesData((prev) => {
                const updated = [...prev];
                if (!updated[0]) updated[0] = { items: [] };

                updated[0].items[0] = {
                  ...(updated[0].items[0] || {}),
                  subTest: {
                    ...(updated[0].items[0]?.subTest || {}),
                    synonyms: synonymsRes || [],
                  },
                };

                return updated;
              });
            },
            (error) => {
              console.error("Error fetching synonyms:", error);
              EventService.emit("showError", {
                message: "Failed to load synonyms for this test",
              });
            }
          );
        },
        (error) => {
          console.error("Error fetching sub test data:", error);
          EventService.emit("showError", {
            message: "Failed to load LOINC data for this test",
          });
        }
      );
    }
  };

  const handleSaveSynonyms = () => {
    const synonymsArray =
      labPagesData?.[0]?.items?.[0]?.subTest?.synonyms || [];

    const newSynonyms = synonymsArray
      .filter((syn) => syn.isNew)
      .map((syn) => syn.value)
      .filter((val) => val?.trim() !== "");

    if (newSynonyms.length === 0) {
      EventService.emit("showError", { message: "No new synonyms to save" });
      return;
    }

    const labTestValue = labPagesData[0].items[0].labTest?.value?.value;
    const subTestValue = labPagesData[0].items[0].subTest?.value;
    const payload = {
      ltCode: labTestValue,
      sltCode: subTestValue,
      synonyms: newSynonyms,
    };

    updatetrackingservice.handleSaveSynonyms(
      payload,
      (res) => {
        if (res[0]?.error) {
          EventService.emit("showError", { message: res[0].error });
        } else {
          EventService.emit("showError", { message: "Saved successfully" });
          if (subTestValue) {
            updatetrackingservice.getSynonyms(
              subTestValue,
              (synonymsRes) => {
                setLabPagesData((prev) => {
                  const updated = [...prev];
                  if (!updated[0]) updated[0] = { items: [] };

                  updated[0].items[0] = {
                    ...(updated[0].items[0] || {}),
                    subTest: {
                      ...(updated[0].items[0]?.subTest || {}),
                      synonyms: synonymsRes || [],
                    },
                  };

                  return updated;
                });
              },
              (error) => {
                console.error("Error fetching synonyms:", error);
                EventService.emit("showError", {
                  message: "Failed to load synonyms for this test",
                });
              }
            );
          }
        }
      },
      (err) => {
        console.error("Failed to save synonyms:", err);
        EventService.emit("showError", { message: "Save failed" });
      }
    );
  };

  return (
    <>
      <div className="navigo-module-dashboard-table-container document-digitisation-dashboard">
        <div className="navigo-appoint-container">
          <div className="navigo-appoint-section-8">
            <div
              className="navigo-appoint-section-1"
              onClick={() => {
                helper.navigateTo(props, "/");
              }}
            >
              <FontIcon style={{ fontSize: "36px" }}>arrow_back</FontIcon>
            </div>
            <h1 className="navigo-appoint-section-2">
              Lab report digitisation
            </h1>
            <div
              className="navigo-module-buttons-container"
              style={{ marginTop: "20px" }}
            >
              <TextField2
                lineDirection="left"
                style={{ width: "120px" }}
                placeholder="Patient ID"
                type="text"
                value={searchPid}
                onChange={(e) => {
                  let value = e.replace(/\D/g, "");
                  if (value.length > 8) return;
                  setSearchPid(value == "" ? "" : Number(value));
                  if (value == "") {
                    let removedFilterObj = filterObj;
                    delete removedFilterObj.patientIds;
                    setFilterObj((prev) => {
                      const copy = { ...prev };
                      delete copy.patientIds;
                      return { ...copy, pageNum: 1 };
                    });
                  }
                }}
              />
              <div className="navigo-module-buttons-right-alignment">
                <Button
                  raised
                  className={
                    searchPid == ""
                      ? "navigo-module-button-save-disabled"
                      : "navigo-module-button-save-enabled"
                  }
                  disabled={searchPid == ""}
                  onClick={() => {
                    if (searchPid != "") {
                      setFilterObj({
                        ...filterObj,
                        pageNum: 1,
                        patientIds: [searchPid],
                      });
                      setPageNum(1);
                    }
                  }}
                >
                  {"Search"}
                </Button>
              </div>
              <TextField2
                lineDirection="left"
                style={{ width: "120px", marginLeft: "15px" }}
                placeholder="Appointment ID"
                type="text"
                value={searchAppid}
                onChange={(e) => {
                  let value = e.replace(/\D/g, "");
                  if (value.length > 8) return;
                  setSearchAppid(value == "" ? "" : Number(value));
                  if (value == "") {
                    let removedFilterObj = filterObj;
                    delete removedFilterObj.appointmentIds;
                    setFilterObj((prev) => {
                      const copy = { ...prev };
                      delete copy.patientIds;
                      return { ...copy, pageNum: 1 };
                    });
                  }
                }}
              />
              <div className="navigo-module-buttons-right-alignment">
                <Button
                  raised
                  className={
                    searchAppid == ""
                      ? "navigo-module-button-save-disabled"
                      : "navigo-module-button-save-enabled"
                  }
                  disabled={searchAppid == ""}
                  onClick={() => {
                    if (searchAppid != "") {
                      setFilterObj({
                        ...filterObj,
                        pageNum: 1,
                        appointmentIds: [searchAppid],
                      });
                      setPageNum(1);
                    }
                  }}
                >
                  {"Search"}
                </Button>
              </div>
            </div>
            <div className="navigo-appoint-section-4-bottom-button-container">
              <Button
                raised
                className={"navigo-module-button-save-enabled1"}
                onClick={() => {
                  setDatabaseModal(true);
                }}
              >
                {"Update database"}
              </Button>
            </div>
            <div className="navigo-appoint-section-4-bottom-button-container">
              <Button
                raised
                className={"navigo-module-button-save-enabled"}
                onClick={() => {
                  setDigitiseModal(true);
                }}
              >
                {"Digitise report"}
              </Button>
            </div>
          </div>

          <div className="navigo-appoint-section-5">
            <div className="navigo-appoint-section-5-grid-container-document">
              <div className="navigo-appoint-section-5-grid-container-common-section ">
                <p>
                  Patient
                  <br /> ID &nbsp;
                </p>
              </div>

              <div className="navigo-appoint-section-5-grid-container-common-section">
                <p>
                  Document
                  <br /> ID
                </p>
              </div>
              <div className="navigo-appoint-section-5-grid-container-common-section">
                <p>
                  Appointment <br /> ID
                </p>
              </div>

              <div className="navigo-appoint-section-5-grid-container-common-section ">
                <p>
                  Account <br /> code
                </p>
                <img
                  src={
                    filterAccountCodeOptions.length > 0
                      ? filterApplied
                      : funnelIcon
                  }
                  onClick={() => {
                    setOpenBackdrop(true);
                    setOpenFilter(8);
                  }}
                />
                {openFilter === 8 && (
                  <div className="navigo-appoint-section-5-grid-container-section-common-filter-popup-city">
                    <Autocomplete
                      style={{
                        width: "100%",
                        maxHeight: "200px",
                        overflowY: "scroll",
                        overflowX: "hidden",
                      }}
                      multiple
                      id="navigo-multiple-limit-acc-name"
                      options={accountCodeOptions}
                      getOptionLabel={(option) => option.accountCode}
                      value={filterAccountCodeOptions}
                      onChange={(e, v) => {
                        if (v) {
                          setFilterAccountCodeOptions(v);
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          onChange={(e, v) => {
                            // handleFetchAccountCodeOpt(e.target.value);
                          }}
                          {...params}
                          placeholder=""
                          className="autocomplete-text-field-class"
                        />
                      )}
                    />
                  </div>
                )}
              </div>
              <div className="navigo-appoint-section-5-grid-container-common-section ">
                <p>
                  Total <br />
                  parameters
                </p>
              </div>
              <div className="navigo-appoint-section-5-grid-container-common-section ">
                <p>
                  Digitised <br />
                  parameters
                </p>
              </div>
              <div className="navigo-appoint-section-5-grid-container-common-section ">
                <p>
                  Service <br /> code
                </p>
                <img
                  src={
                    filterServiceCodeOptions.length > 0
                      ? filterApplied
                      : funnelIcon
                  }
                  onClick={() => {
                    setOpenBackdrop(true);
                    setOpenFilter(9);
                  }}
                />
                {openFilter === 9 && (
                  <div className="navigo-appoint-section-5-grid-container-section-common-filter-popup-city">
                    <Autocomplete
                      style={{
                        width: "100%",
                        maxHeight: "200px",
                        overflowY: "scroll",
                        overflowX: "hidden",
                      }}
                      multiple
                      id="navigo-multiple-limit-service-code"
                      options={serviceCodeOptions}
                      getOptionLabel={(option) => option.name}
                      value={filterServiceCodeOptions}
                      onChange={(e, v) => {
                        if (v) {
                          setFilterServiceCodeOptions(v);
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          onChange={(e, v) => {
                            // handleFetchServiceCodeOpt(e.target.value);
                          }}
                          {...params}
                          placeholder=""
                          className="autocomplete-text-field-class"
                        />
                      )}
                    />
                  </div>
                )}
              </div>
              <div className="navigo-appoint-section-5-grid-container-common-section ">
                <p>
                  Service provider <br /> name
                </p>
                <img
                  src={
                    filterServiceProviderNameOptions.length > 0
                      ? filterApplied
                      : funnelIcon
                  }
                  onClick={() => {
                    setOpenBackdrop(true);
                    setOpenFilter(7);
                  }}
                />
                {openFilter === 7 && (
                  <div className="navigo-appoint-section-5-grid-container-section-common-filter-popup-sp1">
                    <Autocomplete
                      style={{
                        width: "100%",
                        maxHeight: "200px",
                        overflowY: "scroll",
                        overflowX: "hidden",
                      }}
                      multiple
                      id="navigo-multiple-limit-service-provider-name"
                      options={serviceProviderNameOptions}
                      getOptionSelected={(option, value) =>
                        option.id === value.id
                      }
                      getOptionLabel={(option) => {
                        if (option.isSelectAll) return option.label;

                        let res =
                          option.serviceTypeId === 3
                            ? `(${option?.id}) ${option?.vaccineInfo?.identityDetails?.name} - ${option?.vaccineInfo?.address?.city} - ${option?.vaccineInfo?.address?.landmark}`
                            : option.serviceTypeId === 2
                            ? `(${option?.id}) ${option?.checkupInfo?.identityDetails?.name} - ${option?.checkupInfo?.address?.city} - ${option?.checkupInfo?.address?.landmark}`
                            : option.serviceTypeId === 1
                            ? `(${option?.id}) ${option?.consultationInfo?.identityDetails?.name}`
                            : "";
                        return res || "";
                      }}
                      filterOptions={(options, { inputValue }) => {
                        const searchText = inputValue.toLowerCase();

                        const filtered = options.filter((option) => {
                          let label = "";

                          if (option.serviceTypeId === 2) {
                            label = `(${option.id}) ${option?.checkupInfo?.identityDetails?.name} - ${option?.checkupInfo?.address?.city} - ${option?.checkupInfo?.address?.landmark}`;
                          } else if (option.serviceTypeId === 3) {
                            label = `(${option.id}) ${option?.vaccineInfo?.identityDetails?.name}`;
                          } else if (option.serviceTypeId === 1) {
                            label = `(${option.id}) ${option?.consultationInfo?.identityDetails?.name}`;
                          }

                          return label.toLowerCase().includes(searchText);
                        });

                        if (filtered.length > 0 && searchText.trim() !== "") {
                          return [
                            {
                              id: "__select_all__",
                              label: `Select all options with "${inputValue}"`,
                              isSelectAll: true,
                              matchedOptions: filtered,
                            },
                            ...filtered,
                          ];
                        }

                        return filtered;
                      }}
                      value={filterServiceProviderNameOptions}
                      onChange={(event, newValue) => {
                        // check "Select All" was clicked-----
                        const selectAllEntry = newValue.find(
                          (val) => val?.isSelectAll
                        );

                        if (selectAllEntry) {
                          // merge current selections with new matched options (avoid duplicates)
                          const merged = [
                            ...filterServiceProviderNameOptions,
                            ...selectAllEntry.matchedOptions,
                          ];

                          // remove duplicates based on ID
                          const deduplicated = Array.from(
                            new Map(
                              merged.map((item) => [item.id, item])
                            ).values()
                          );

                          setFilterServiceProviderNameOptions(deduplicated);
                        } else {
                          setFilterServiceProviderNameOptions(newValue);
                        }
                      }}
                      renderTags={(value, getTagProps) =>
                        value
                          .filter((option) => !option.isSelectAll)
                          .map((option, index) => {
                            let label = "";

                            if (option.serviceTypeId === 3) {
                              const name =
                                option?.vaccineInfo?.identityDetails?.name;
                              const city = option?.vaccineInfo?.address?.city;
                              const landmark =
                                option?.vaccineInfo?.address?.landmark;
                              label = `(${option.id}) ${name} - ${city} - ${landmark}`;
                            } else if (option.serviceTypeId === 2) {
                              const name =
                                option?.checkupInfo?.identityDetails?.name;
                              const city = option?.checkupInfo?.address?.city;
                              const landmark =
                                option?.checkupInfo?.address?.landmark;
                              label = `(${option.id}) ${name} - ${city} - ${landmark}`;
                            } else if (option.serviceTypeId === 1) {
                              const name =
                                option?.consultationInfo?.identityDetails?.name;
                              label = `(${option.id}) ${name}`;
                            }

                            return (
                              <Chip
                                key={option.id}
                                label={label}
                                style={{ marginRight: 4 }}
                                {...getTagProps({ index })}
                              />
                            );
                          })
                      }
                      renderInput={(params) => (
                        <TextField
                          onChange={(e, v) => {
                            // handleFetchServiceProviderNameOpt(e.target.value);
                          }}
                          {...params}
                          placeholder=""
                          className="autocomplete-text-field-class"
                        />
                      )}
                      renderOption={(option, { inputValue }) => {
                        if (option.isSelectAll) {
                          return <strong>{option.label}</strong>;
                        }

                        let label = "";
                        if (option.serviceTypeId === 3) {
                          label = `(${option.id}) ${option?.vaccineInfo?.identityDetails?.name} - ${option?.vaccineInfo?.address?.city} - ${option?.vaccineInfo?.address?.landmark}`;
                        } else if (option.serviceTypeId === 2) {
                          label = `(${option.id}) ${option?.checkupInfo?.identityDetails?.name} - ${option?.checkupInfo?.address?.city} - ${option?.checkupInfo?.address?.landmark}`;
                        } else if (option.serviceTypeId === 1) {
                          label = `(${option.id}) ${option?.consultationInfo?.identityDetails?.name}`;
                        }

                        const lowerLabel = label.toLowerCase();
                        const lowerInput = inputValue.toLowerCase();
                        const index = lowerLabel.indexOf(lowerInput);

                        if (index === -1 || inputValue.trim() === "") {
                          return <span>{label}</span>;
                        }

                        const before = label.substring(0, index);
                        const match = label.substring(
                          index,
                          index + inputValue.length
                        );
                        const after = label.substring(
                          index + inputValue.length
                        );

                        return (
                          <span>
                            {before}
                            <span
                              style={{
                                fontWeight: 700,
                                // backgroundColor: "#EBEBEB",
                              }}
                            >
                              {match}
                            </span>
                            {after}
                          </span>
                        );
                      }}
                    />
                  </div>
                )}
              </div>
              <div className="navigo-appoint-section-5-grid-container-common-section ">
                <p>
                  Digitisation <br /> date
                </p>
                <img
                  src={
                    filterObj?.digitisationDate?.from ||
                    filterObj?.digitisationDate?.to
                      ? filterApplied
                      : funnelIcon
                  }
                  onClick={() => {
                    setOpenBackdrop(true);
                    setOpenFilter(3);
                  }}
                />
                {openFilter === 3 && (
                  <div className="navigo-appoint-section-5-grid-container-section-common-filter-popup">
                    <div className="navigo-appointment-date-range-filter ">
                      <p>From</p>
                      <TextField
                        type="date"
                        style={{ width: "90%" }}
                        className="dob"
                        id="dob"
                        onChange={(v) => {
                          if (v.target.value) {
                            setDigitisationDateFrom(v.target.value);
                          }
                        }}
                        // inputProps={{ max: maxDate }}
                        value={digitisationDateFrom}
                      ></TextField>
                    </div>
                    <div className="navigo-appointment-date-range-filter ">
                      <p>To</p>
                      <TextField
                        type="date"
                        defaultValue={""}
                        style={{ width: "90%" }}
                        className="dob"
                        id="dob"
                        onChange={(v) => {
                          if (v.target.value) {
                            setDigitisationDateTo(v.target.value);
                          }
                        }}
                        // inputProps={{ max: maxDate }}
                        value={digitisationDateTo}
                      ></TextField>
                    </div>
                    <Button
                      className=""
                      style={{
                        padding: "3px",
                        margin: "0px 5px",
                        backgroundColor: "#c3c3c3",
                      }}
                      onClick={() => {
                        setFilterObj({
                          ...filterObj,
                          pageNum: 1,
                          digitisationDate: {
                            from: moment(digitisationDateFrom)
                              .utc()
                              .startOf("day")
                              .add(1, "day")
                              .toISOString(),

                            to: moment(digitisationDateTo)
                              .utc()
                              .endOf("day")
                              .add(1, "day")
                              .toISOString(),
                          },
                        });
                        setPageNum(1);
                        setOpenFilter(0);
                        setOpenBackdrop(false);
                      }}
                    >
                      Go
                    </Button>
                    <Button
                      className=""
                      onClick={() => {
                        let removedFilterObj = filterObj;
                        delete removedFilterObj.digitisationDate;
                        setFilterObj((prev) => {
                          const copy = { ...prev };
                          delete copy.patientIds;
                          return { ...copy, pageNum: 1 };
                        });
                        setDigitisationDateFrom(null);
                        setDigitisationDateTo(null);
                        setPageNum(1);
                        setOpenFilter(0);
                        setOpenBackdrop(false);
                      }}
                    >
                      <FontIcon className="">close</FontIcon>
                    </Button>
                  </div>
                )}
              </div>
              <div className="navigo-appoint-section-5-grid-container-common-section ">
                <p>
                  Appointment <br /> date
                </p>
                <img
                  src={
                    filterObj?.appointmentDate?.from ||
                    filterObj?.appointmentDate?.to
                      ? filterApplied
                      : funnelIcon
                  }
                  onClick={() => {
                    setOpenBackdrop(true);
                    setOpenFilter(4);
                  }}
                />
                {openFilter === 4 && (
                  <div className="navigo-appoint-section-5-grid-container-section-common-filter-popup">
                    <div className="navigo-appointment-date-range-filter ">
                      <p>From</p>
                      <TextField
                        type="date"
                        style={{ width: "90%" }}
                        className="dob"
                        id="dob"
                        onChange={(v) => {
                          if (v.target.value) {
                            setAppointmentDateFrom(v.target.value);
                          }
                        }}
                        // inputProps={{ max: maxDate }}
                        value={appointmentDateFrom}
                      ></TextField>
                    </div>
                    <div className="navigo-appointment-date-range-filter ">
                      <p>To</p>
                      <TextField
                        type="date"
                        defaultValue={""}
                        style={{ width: "90%" }}
                        className="dob"
                        id="dob"
                        onChange={(v) => {
                          if (v.target.value) {
                            setAppointmentDateTo(v.target.value);
                          }
                        }}
                        // inputProps={{ max: maxDate }}
                        value={appointmentDateTo}
                      ></TextField>
                    </div>
                    <Button
                      className=""
                      style={{
                        padding: "3px",
                        margin: "0px 5px",
                        backgroundColor: "#c3c3c3",
                      }}
                      onClick={() => {
                        setFilterObj({
                          ...filterObj,
                          pageNum: 1,
                          appointmentDate: {
                            from: moment(appointmentDateFrom)
                              .utc()
                              .startOf("day")
                              .add(1, "day")
                              .toISOString(),

                            to: moment(appointmentDateTo)
                              .utc()
                              .endOf("day")
                              .add(1, "day")
                              .toISOString(),
                          },
                        });
                        setPageNum(1);
                        setOpenFilter(0);
                        setOpenBackdrop(false);
                      }}
                    >
                      Go
                    </Button>
                    <Button
                      className=""
                      onClick={() => {
                        let removedFilterObj = filterObj;
                        delete removedFilterObj.appointmentDate;
                        setFilterObj((prev) => {
                          const copy = { ...prev };
                          delete copy.patientIds;
                          return { ...copy, pageNum: 1 };
                        });
                        setAppointmentDateFrom(null);
                        setAppointmentDateTo(null);
                        setPageNum(1);
                        setOpenFilter(0);
                        setOpenBackdrop(false);
                      }}
                    >
                      <FontIcon className="">close</FontIcon>
                    </Button>
                  </div>
                )}
              </div>
              <div className="navigo-appoint-section-5-grid-container-common-section ">
                <p>
                  Updated
                  <br /> on
                </p>
                <img
                  src={
                    filterObj?.updatedAt?.from || filterObj?.updatedAt?.to
                      ? filterApplied
                      : funnelIcon
                  }
                  onClick={() => {
                    setOpenBackdrop(true);
                    setOpenFilter(1);
                  }}
                />
                {openFilter === 1 && (
                  <div className="navigo-appoint-section-5-grid-container-section-common-filter-popup">
                    <div className="navigo-appointment-date-range-filter ">
                      <p>From</p>
                      <TextField
                        type="date"
                        style={{ width: "90%" }}
                        className="dob"
                        id="dob"
                        onChange={(v) => {
                          if (v.target.value) {
                            setCreationDateFrom(v.target.value);
                          }
                        }}
                        inputProps={{ max: maxDate }}
                        value={creationDateFrom}
                      ></TextField>
                    </div>
                    <div className="navigo-appointment-date-range-filter ">
                      <p>To</p>
                      <TextField
                        type="date"
                        defaultValue={""}
                        style={{ width: "90%" }}
                        className="dob"
                        id="dob"
                        onChange={(v) => {
                          if (v.target.value) {
                            setCreationDateTo(v.target.value);
                          }
                        }}
                        inputProps={{ max: maxDate }}
                        value={creationDateTo}
                      ></TextField>
                    </div>
                    <Button
                      className=""
                      style={{
                        padding: "3px",
                        margin: "0px 5px",
                        backgroundColor: "#c3c3c3",
                      }}
                      onClick={() => {
                        setFilterObj({
                          ...filterObj,
                          pageNum: 1,
                          updatedAt: {
                            from: moment(creationDateFrom)
                              .utc()
                              .startOf("day")
                              .add(1, "day")
                              .toISOString(),

                            to: moment(creationDateTo)
                              .utc()
                              .endOf("day")
                              .add(1, "day")
                              .toISOString(),
                          },
                        });
                        setPageNum(1);
                        setOpenFilter(0);
                        setOpenBackdrop(false);
                      }}
                    >
                      Go
                    </Button>
                    <Button
                      className=""
                      onClick={() => {
                        let removedFilterObj = filterObj;
                        delete removedFilterObj.updatedAt;
                        setFilterObj((prev) => {
                          const copy = { ...prev };
                          delete copy.patientIds;
                          return { ...copy, pageNum: 1 };
                        });
                        setCreationDateFrom(null);
                        setCreationDateTo(null);
                        setPageNum(1);
                        setOpenFilter(0);
                        setOpenBackdrop(false);
                      }}
                    >
                      <FontIcon className="">close</FontIcon>
                    </Button>
                  </div>
                )}
              </div>
              <div className="navigo-appoint-section-5-grid-container-common-section ">
                <p>
                  Reviewed
                  <br /> by
                </p>
              </div>
              <div className="navigo-appoint-section-5-grid-container-common-section ">
                <p>
                  Status <br /> &nbsp;
                </p>
                <img
                  src={
                    statusFilterValue.length > 0 ? filterApplied : funnelIcon
                  }
                  onClick={() => {
                    setOpenBackdrop(true);
                    setOpenFilter(6);
                  }}
                />
                {openFilter === 6 && (
                  <div className="navigo-appoint-section-5-grid-container-section-common-filter-popup-status">
                    <Autocomplete
                      multiple
                      id="navigo-appointment-dialog-client-code-filter"
                      className="appointment-dialog-client-code-filter-class"
                      options={documentStatus}
                      value={statusFilterValue}
                      onChange={(e, v) => {
                        if (v.length > 0) {
                          setStatusFilterValue(v);
                        } else {
                          setStatusFilterValue([]);
                        }
                      }}
                      getOptionLabel={(option) => {
                        return option.name;
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder={"Type status name"}
                          className="autocomplete-text-field-class"
                        />
                      )}
                    />
                  </div>
                )}
              </div>
              {areFiltersApplied() && (
                <div
                  onClick={() => {
                    setRemoveFilters(true);
                  }}
                  style={{
                    display: "inline-block",
                    cursor: "pointer",
                  }}
                >
                  <FontIcon style={{ fontSize: "22px" }}>
                    highlight_remove
                  </FontIcon>
                </div>
              )}
            </div>
          </div>
          <div className="navigo-appoint-section-6">
            {appointmentsList && appointmentsList.length > 0 && (
              <div className="navigo-appoint-bottom-bar">
                <Button
                  className="navigo-appoint-bottom-bar-button"
                  onClick={() => {
                    handlePrevNextAppoint(0);
                  }}
                  disabled={pageNum == 1 || loading}
                >
                  <FontIcon className="navigo-count-icon">
                    arrow_drop_up
                  </FontIcon>
                </Button>
                <div className="navigo-appoint-bottom-bar-text">
                  Showing&nbsp;
                  <span
                    style={{
                      color: "#ef7c01",
                    }}
                  >
                    {(pageNum - 1) * pageSize + 1}&nbsp;- &nbsp;
                    {totalCount > pageNum * pageSize
                      ? pageNum * pageSize
                      : totalCount}
                  </span>
                  <span>&nbsp;of&nbsp;</span>
                  <span>{` ${totalCount}`}</span>
                </div>
                <Button
                  className="navigo-appoint-bottom-bar-button"
                  onClick={() => {
                    handlePrevNextAppoint(1);
                  }}
                  disabled={
                    loading ||
                    pageNum * pageSize > totalCount ||
                    (totalCount > pageNum * pageSize
                      ? pageNum * pageSize
                      : totalCount) == totalCount
                  }
                >
                  <FontIcon className="navigo-count-icon">
                    arrow_drop_down
                  </FontIcon>
                </Button>
              </div>
            )}
            {loading == false && (
              <div className="navigo-appoint-section-6-list">
                {appointmentsList &&
                  appointmentsList.map((ele) => {
                    return (
                      <div
                        className="navigo-appoint-section-6-grid-container-document"
                        key={ele.id}
                      >
                        <div className="general-font-class ">
                          {/* The patient's HEALTH RECORD — bridge's phr record,
                              /patient-record/:patientId (App.js) — in the SAME
                              tab, as a router Link (Nittin, 2026-09-25). It
                              opened the legacy patients/new-bridge screen in a
                              new one; the appointment-details screen, the
                              appointments-v2 board and the claims dashboard all
                              made this same swap. Still an anchor underneath,
                              so it can be middle-clicked or copied. */}
                          <Link
                            className="general-font-class general-cursor-pointer navigo-appointment-break-word-class"
                            to={`/patient-record/${ele.patientId}`}
                          >
                            {ele.patientId}
                          </Link>
                        </div>
                        <div className="general-font-class">
                          {ele.documentId}
                        </div>

                        <div className="general-font-class ">
                          {ele.appointmentId ? ele.appointmentId : "-"}
                        </div>
                        <div className="general-font-class">
                          {ele.accountCode ? ele.accountCode : "-"}
                        </div>
                        <div className="general-font-class">
                          {ele.digitisedParamCount}
                        </div>
                        <div className="general-font-class">
                          {ele.mappedParamCount}
                        </div>
                        <div className="general-font-class">
                          {ele.serviceCode ? ele.serviceCode : "-"}
                        </div>
                        <div className="general-font-class">
                          {ele.serviceProviderName
                            ? ele.serviceProviderName
                            : "-"}
                        </div>
                        <div className="navigo-digitisation-date-cell">
                          <span className="navigo-digitisation-date-value">
                            {ele.digitisationDate &&
                            ele.digitisationDate !== "0001-01-01T00:00:00Z"
                              ? moment
                                  .utc(ele.digitisationDate)
                                  .format("DD MMM YYYY")
                              : "-"}
                          </span>
                          <span
                            className="navigo-digitisation-model-tag"
                            style={{
                              color: getModelInfo(ele.digitisationModel).color,
                            }}
                            title="Model and digitisation cost of this report"
                          >
                            {getModelInfo(ele.digitisationModel).name}
                            {formatDigitisationCost(ele.digitisationCostInr) &&
                              ` · ${formatDigitisationCost(
                                ele.digitisationCostInr
                              )}`}
                          </span>
                        </div>

                        <div className="general-font-class">
                          {ele.appointmentDate &&
                          ele.appointmentDate !== "0001-01-01T00:00:00Z"
                            ? moment
                                .utc(ele.appointmentDate)
                                .format("DD MMM YYYY")
                            : "-"}
                        </div>

                        <div className="general-font-class">
                          {ele.updatedAt &&
                          ele.updatedAt !== "0001-01-01T00:00:00Z"
                            ? moment.utc(ele.updatedAt).format("DD MMM YYYY")
                            : "-"}
                        </div>

                        <div className="general-font-class">
                          {ele.reviewedByName ? ele.reviewedByName : "-"}
                        </div>
                        <div className="navigo-appoint-section-6-grid-status-eye">
                          <div className="navigo-appoint-section-6-grid-status">
                            <div
                              className={`custom-status-display ${
                                ele.status === 1 || ele.status === 4
                                  ? "closed-class"
                                  : ele.status === 2
                                  ? "progress-class"
                                  : ele.status === 3
                                  ? "invalid-class"
                                  : "progress-class"
                              }`}
                            >
                              {getStatusName(ele.status)}
                            </div>
                          </div>

                          {ele.status != 4 ? (
                            <IconButton
                              onClick={(e) => handleClick(e, ele)}
                              className="navigo-appoint-section-6-grid-edit-call"
                            >
                              <img
                                src={eyeIcon}
                                alt="View"
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  objectFit: "contain",
                                }}
                              />
                            </IconButton>
                          ) : (
                            // status 4 (In progress) hides the eye; keep an empty spacer the
                            // same width so the status badge stays aligned with the other rows.
                            <span className="navigo-appoint-section-6-grid-eye-placeholder" />
                          )}
                        </div>
                      </div>
                    );
                  })}
              </div>
            )}

            {loading && <GlobalSkeletonLoader />}
            {loading === false && noAppointments && (
              <div className="no-appointments-container">
                <p>No document found!</p>
              </div>
            )}
          </div>
          {openBackdrop && (
            <div
              className="navigo-appointment-backdrop-class"
              onClick={() => {
                setOpenFilter(0);
                setOpenBackdrop(false);
              }}
            ></div>
          )}
        </div>
        {digitiseModal && (
          <Modal open={digitiseModal}>
            <div className="modal-overlay">
              <div className="modal">
                <h2>{"Digitise report"}</h2>
                <p className="info-line">
                  *Please select the document ID carefully. Once tracking data
                  has been entered, but not saved, all entered data will be
                  lost.
                </p>
                <div className="modal-content">
                  <div className="service-type">
                    <label htmlFor="serviceType">Patient Id</label>
                    <input
                      id="serviceType"
                      className="service-type-field"
                      type="text"
                      placeholder="Enter Patient ID"
                      value={patientId}
                      onChange={handlePatientIdChange}
                    />
                  </div>
                  <div className="doc-drop-down">
                    <label htmlFor="documentId">Document ID*</label>
                    <select
                      id="documentId"
                      className="drop-down-menu"
                      defaultValue=""
                      onChange={onDocumentIdUpdate}
                    >
                      <option value="" disabled>
                        Select Document ID
                      </option>
                      {documentIds.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.id}
                        </option>
                      ))}
                    </select>
                  </div>
                  <button
                    className="modal-close-button"
                    onClick={() => {
                      setDigitiseModal(false);
                      setPatientId("");
                      setDocumentIds([]);
                      setSelectedDocumentId(0);
                    }}
                  >
                    &times;
                  </button>
                </div>
                <div className="modal-buttons">
                  <button
                    className="view-doc-button"
                    onClick={viewDocument}
                    disabled={!selectedDocumentId}
                  >
                    View Document
                  </button>
                  <button
                    className="confirm-doc-button"
                    style={{ marginRight: "8px" }}
                    onClick={handleDigitise}
                    disabled={!selectedDocumentId}
                  >
                    Digitise now
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        )}
        {digitiseSuccessModal && (
          <Modal open={digitiseSuccessModal}>
            <div className="modal-overlay">
              <div className="modal success-modal">
                <button
                  className="modal-close-button"
                  onClick={() => setDigitiseSuccessModal(false)}
                >
                  &times;
                </button>
                <h2>Digitise report</h2>
                <p
                  style={{
                    marginTop: "12px",
                    fontSize: "16px",
                    textAlign: "center",
                  }}
                >
                  Digitisation has started and it will take 5–10 minutes to
                  complete the process. Once completed, the entry will appear on
                  the dashboard.
                </p>
              </div>
            </div>
          </Modal>
        )}
        {databaseModal && (
          <Modal open={databaseModal}>
            <div className="modal-overlay-update">
              <div className="modal-content-update">
                <div className="modal-header">
                  <h2 className="modal-title">Update database</h2>
                  <button
                    className="close-button"
                    onClick={() => {
                      setDatabaseModal(false);
                      setLabPagesData([]);
                    }}
                  >
                    &times;
                  </button>
                </div>

                <div className="input-grid">
                  <div className="input-grid">
                    <div className="input-field">
                      <div className="label">Lab Test</div>
                      <Autocomplete
                        options={labTestData}
                        getOptionLabel={(option) => option.label || ""}
                        onInputChange={(e, newValue, reason) => {
                          if (reason === "input") {
                            fire(newValue);
                          }
                        }}
                        onChange={(e, value) => {
                          if (value) {
                            OnSelect(value);
                          } else {
                            // setLabPagesData((prev) => {
                            //   const updated = [...prev];
                            //   if (updated[0]?.items?.[0]) {
                            //     updated[0].items[0] = {
                            //       ...updated[0].items[0],
                            //       labTest: null,
                            //       subTest: {
                            //         subTestCode: { label: "", value: "" },
                            //         loincCode: "",
                            //         synonyms: [],
                            //         name: "",
                            //       },
                            //       loincName: "",
                            //       value: "",
                            //       unit: "",
                            //       range: "",
                            //       description: "",
                            //       testDate: "",
                            //     };
                            //   }
                            //   return updated;
                            // });
                            setLabPagesData([]);
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Select lab test"
                            variant="standard"
                            size="small"
                          />
                        )}
                      />
                    </div>

                    <div className="input-field">
                      <div className="label">Sub Test</div>
                      <Autocomplete
                        options={subLabTestData}
                        value={
                          labPagesData?.[0]?.items?.[0]?.subTest?.subTestCode ||
                          null
                        }
                        getOptionLabel={(option) => option.label || ""}
                        onInputChange={(event, value) => {
                          const labTest =
                            labPagesData?.[0]?.items?.[0]?.labTest?.value;

                          if (value.length > 1 && labTest.value) {
                            getSubLabTests(value, labTest.value);
                          } else {
                            setSubLabTestData([]);
                          }
                        }}
                        onChange={(e, value) => {
                          if (value) {
                            handleSubTestSelect(value);
                          } else {
                            setLabPagesData((prev) => {
                              const updated = [...prev];
                              if (updated[0]?.items?.[0]) {
                                updated[0].items[0] = {
                                  ...updated[0].items[0],
                                  subTest: null,
                                  loincName: "",
                                  synonyms: [],
                                  value: "",
                                  unit: "",
                                  range: "",
                                  description: "",
                                  testDate: "",
                                };
                              }
                              return updated;
                            });
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Select sub lab test"
                            variant="standard"
                            size="small"
                          />
                        )}
                        // disableClearable={false}
                        clearOnBlur={false}
                      />
                    </div>

                    <div className="input-field-full">
                      <div className="label">LOINC Name</div>
                      <input
                        type="text"
                        className="input-underline"
                        value={
                          labPagesData?.[0]?.items?.[0]?.subTest?.loincCode ||
                          ""
                        }
                      />
                    </div>
                  </div>

                  <div className="synonyms-section input-field-full">
                    <div className="label">Synonyms</div>
                    <div className="synonym-list flex flex-wrap gap-2">
                      {(
                        labPagesData?.[0]?.items?.[0]?.subTest?.synonyms || []
                      ).map((syn, idx) => {
                        const value = syn.value ?? syn.name ?? "";
                        const isNew = syn.isNew ?? false;

                        return (
                          <div
                            key={idx}
                            className="flex items-center gap-2 mb-2"
                          >
                            {isNew ? (
                              <>
                                <input
                                  type="text"
                                  placeholder="Type here"
                                  value={value}
                                  onChange={(e) => {
                                    const newValue = e.target.value;
                                    setLabPagesData((prev) => {
                                      const updated = [...prev];
                                      updated[0].items[0].subTest.synonyms[
                                        idx
                                      ] = {
                                        ...updated[0].items[0].subTest.synonyms[
                                          idx
                                        ],
                                        value: newValue,
                                        isNew: true,
                                      };
                                      return updated;
                                    });
                                  }}
                                  className="synonym-input"
                                />
                                <button
                                  type="button"
                                  className="remove-synonym-btn"
                                  onClick={() => {
                                    setLabPagesData((prev) => {
                                      const updated = [...prev];
                                      updated[0].items[0].subTest.synonyms =
                                        updated[0].items[0].subTest.synonyms.filter(
                                          (_, i) => i !== idx
                                        );
                                      return updated;
                                    });
                                  }}
                                >
                                  &times;
                                </button>
                              </>
                            ) : (
                              <div className="synonym-data">{value}</div>
                            )}
                          </div>
                        );
                      })}

                      <button
                        type="button"
                        className="add-synonym-button"
                        onClick={() => {
                          setLabPagesData((prev) => {
                            const updated = [...prev];
                            if (!updated[0]) updated[0] = { items: [] };
                            if (!updated[0].items[0]) updated[0].items[0] = {};
                            if (!updated[0].items[0].subTest)
                              updated[0].items[0].subTest = { synonyms: [] };
                            if (!updated[0].items[0].subTest.synonyms)
                              updated[0].items[0].subTest.synonyms = [];

                            updated[0].items[0].subTest.synonyms.push({
                              value: "",
                              isNew: true,
                            });
                            return updated;
                          });
                        }}
                      >
                        + Add new
                      </button>
                    </div>
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    className="cancel-button"
                    onClick={() => {
                      setDatabaseModal(false);
                      setLabPagesData([]);
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    className="save-button"
                    onClick={() => handleSaveSynonyms()}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        )}
      </div>
    </>
  );
}

export default DocumentDashboard;
